import Typography from 'components/Typography';

import { StyledPrivacyPolicyWrapper } from './styles';

type PrivacyPolicyLinkProps = {
  href: string;
};

const PrivacyPolicyLink = ({ href, children }: PropsWithChildren<PrivacyPolicyLinkProps>) => {
  return (
    <Typography color='weak' variant='body' size='xs'>
      <a href={href} target='_blank' rel='noreferrer'>
        {children}
      </a>
    </Typography>
  );
};

const PrivacyPolicy = ({ id }: { id: string }) => {
  return (
    <StyledPrivacyPolicyWrapper id={id}>
      <Typography as='p' color='weak' variant='body' size='xs'>
        By chatting you accept our{' '}
        <PrivacyPolicyLink href='https://www.carvana.com/terms-of-use'>
          User Agreement
        </PrivacyPolicyLink>{' '}
        and{' '}
        <PrivacyPolicyLink href='https://www.carvana.com/privacy-policy'>
          Financial and Other Privacy Notices
        </PrivacyPolicyLink>
        . Chats may be automated and recorded by us and vendors. CA users, see{' '}
        <PrivacyPolicyLink href='https://www.carvana.com/privacy-policy#consumer-privacy-notice-your-rights'>
          your privacy rights
        </PrivacyPolicyLink>
        .
      </Typography>
    </StyledPrivacyPolicyWrapper>
  );
};

export default PrivacyPolicy;
